@if (isMenu) {
  <button mat-menu-item>
    <mat-icon>report_outline</mat-icon>
    {{ 'markAsSpam' | translate }}
  </button>
} @else {
  <button mat-icon-button matTooltip="{{ 'markAsSpam' | translate }}">
    <mat-icon>report_outline</mat-icon>
  </button>
}
